const colorList = ['blue', 'green', 'orange', 'red', 'gray']

/**
 * 根据现有的颜色通用库随机选择一个颜色返回
 */
export const renderBgColor = function(){
    const len = colorList.length
    return colorList[Math.floor(Math.random() * len)]
}

export const formPromise = function (formRef) {
    return new Promise((resolve, reject) => {
        formRef.validate((valid) => {
            if (valid) {
                resolve()
            } else {
                reject(new Error('不符合规则的表单'))
            }
        })
    })
}


// WEBPACK FOOTER //
// ./src/util/index.js